import { useFetchListData } from '@/composables'
import { defineStore } from 'pinia'
import { computed } from 'vue'

interface ExchangeItem {
  id: number
  name: string
  type: string
}

const useExchangeStore = defineStore('exchange', () => {
  const { data, loading, fetchData } = useFetchListData<ExchangeItem[]>({
    url: '/api/exchange/index',
    params: {
      keyword: '',
    },
    method: 'POST',
    autoFetch: false,
    showErrorMessage: false,
  })

  const exchangeOptions = computed(() => {
    if (!data.value) return []
    return data.value.map((item) => ({ label: item.name, value: item.id }))
  })

  const reset = () => {
    loading.value = false
    data.value = null
    _initPromise = null
  }

  // Idempotent initializer
  let _initPromise: Promise<void> | null = null
  const init = async (params?: Record<string, any>) => {
    if (_initPromise) return _initPromise
    _initPromise = (async () => {
      if (Array.isArray(data.value) && data.value.length > 0) return
      await fetchData(params)
    })()
    return _initPromise
  }

  return {
    loading,
    data,
    exchangeOptions,
    fetchData,
    init,
    reset,
  }
})

export default useExchangeStore
